import React from 'react';

export default function CategoryResolutionSection({ suggestions, resolutions, onChange, categories, testidPrefix }) {
  if (!suggestions?.length) return null;
  return (
    <div className="rounded-lg border border-purple-200 bg-purple-50/50 p-3" data-testid={`${testidPrefix}-category-suggestions`}>
      <div className="mb-2 text-xs font-bold text-purple-700">فئات جديدة مقترحة ({suggestions.length})</div>
      <div className="space-y-3">
        {suggestions.map((s) => {
          const r = resolutions?.[s.name] || {};
          return (
            <div key={s.name} className="rounded-lg border border-slate-200 bg-white p-2" data-testid={`${testidPrefix}-suggestion-${s.name}`}>
              <div className="mb-1 flex items-center justify-between text-xs">
                <span className="font-semibold text-slate-700">{s.name}</span>
                <span className="text-slate-400">{s.player_count} لاعب</span>
              </div>
              <div className="flex flex-wrap items-center gap-2 text-xs">
                <label className="flex items-center gap-1">
                  <input type="radio" checked={r.action === 'link'} onChange={() => onChange(s.name, { action: 'link', category_id: r.category_id || s.suggested_category_id || '' })} data-testid={`${testidPrefix}-action-link-${s.name}`} />
                  ربط بفئة موجودة
                </label>
                {r.action === 'link' && (
                  <select className="rounded border border-slate-200 px-1 py-0.5" value={r.category_id || ''} onChange={(e) => onChange(s.name, { action: 'link', category_id: e.target.value })} data-testid={`${testidPrefix}-link-select-${s.name}`}>
                    <option value="">اختر فئة...</option>
                    {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                )}
                <label className="flex items-center gap-1">
                  <input type="radio" checked={r.action === 'create'} onChange={() => onChange(s.name, { action: 'create', min_age: s.inferred_min_age, max_age: s.inferred_max_age })} data-testid={`${testidPrefix}-action-create-${s.name}`} />
                  إنشاء فئة جديدة{s.is_draft_if_created ? ' (مسودة)' : ''}
                </label>
                <label className="flex items-center gap-1">
                  <input type="radio" checked={r.action === 'ignore'} onChange={() => onChange(s.name, { action: 'ignore' })} data-testid={`${testidPrefix}-action-ignore-${s.name}`} />
                  تجاهل (استيراد بلا فئة)
                </label>
              </div>
              {r.action === 'create' && s.is_draft_if_created && (
                <div className="mt-1 text-[11px] text-amber-600">لا يمكن استنتاج حدود العمر — ستُنشأ كمسودة ولن تدخل النقل التلقائي حتى تحدد حدودها من إدارة الفئات.</div>
              )}
              {r.action === 'create' && !s.is_draft_if_created && (
                <div className="mt-1 text-[11px] text-slate-500">سيتم إنشاؤها بحد أقصى للعمر: {s.inferred_max_age} سنة</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
